import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { SiteDeliveryResponse } from '@/services/Delivery/hooks/list/useCamelOrderDeliveryList';
import { DeliveryUpsertParams } from '@/services/Delivery/hooks/upsert/useCamelOrderDeliveryUpsert';

interface Interface {
  list: () => Promise<SiteDeliveryResponse[]>;
}

export class CamelOrderDeliveryService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async list(): Promise<SiteDeliveryResponse[]> {
    return await this.restClient.get(
      `${TABLET_API_ORIGIN}/dashboard-api/deliveries` as const
    );
  }

  public async upsert(params: DeliveryUpsertParams): Promise<void> {
    return await this.restClient.put(
      `${TABLET_API_ORIGIN}/dashboard-api/deliveries` as const,
      params
    );
  }
}
